export function initTranslate() {
  translate.setAutoDiscriminateLocalLanguage();
  translate.service.use('translate.service');
  translate.request.setHost(['https://translate.wiswift.com/']);
  translate.progress.api.startUITip();
  translate.request.listener.start();
  translate.listener.start();
  translate.whole.enableAll();
  translate.waitingExecute.use = false; // 禁用等待执行

  window.addEventListener("message", (event) => {
    console.log(event,'接受')
    const { type, lang } = event.data || {}
    if (type === "CHANGE_LANG") {
      translate.changeLanguage(lang);
    }
  })

  //触发翻译执行，有关这个的说明可参考 http://translate.zvo.cn/547814.html
  translate.execute();
}



// WEBPACK FOOTER //
// ./src/utils/translate.js